module.exports = __webpack_public_path__ + "media/cycles-start@xs-a609bccfed66e2e7cf3790853564a090.jpg";